import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { ShareConfigFragmentDoc } from '../../../../lyearn-connect/views/LyearnConnectDetails/graphql/fragments/generated/shareconfig';
import { SharedByWorkspaceFragmentDoc } from '../../../../lyearn-connect/views/LyearnConnectDetails/graphql/fragments/generated/sharedByWorkspace';
import { EventInstructorFragmentDoc } from './EventInstructor';
import { UserFragmentDoc } from '../../../../../graphql/fragments/generated/User';
import { ScheduleFragmentDoc } from '../../../../1on1s/graphql/fragment/generated/Schedule';
export type ListRecurringOfflineEventFragment = { id: string, name: string, description?: string | null, objective: string, status: Types.EventStatusEnum, type: Types.EventTypeEnum, latestUpcomingEventId?: string | null, recurringEventSlotCount?: number | null, startTime: string, endTime: string, usersCount: number, isFillingFast: boolean, isUserRegistered: boolean, registrationCloseTime?: string | null, isUserInstructor: boolean, recurringCategory?: Types.RecurringTypeEnum | null, shareConfigs?: Array<{ status: Types.ShareConfigStatusEnum, workspaceId: string, sharedAt: string, sharedById: string, sourceWorkspaceEntityId?: string | null }> | null, sharedByWorkspace?: { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null } | null, instructors: Array<{ alias?: string | null, id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null }>, cover?: { mediaId: string, name: string, url?: string | null, kind: Types.MediaKindEnum } | null, registrationSettings?: { seatLimit?: number | null, closeRegistrationBeforeStart: number, multiSlotRegistration?: boolean | null } | null, recurrenceSchedule?: { frequency: Types.CronFrequencyEnum, timezone: string, time: string, dayOfWeek?: Types.DayOfWeekEnum | null, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, MonthOfYear?: Types.MonthOfYearEnum | null, startDate?: string | null, custom?: { frequency: Types.CustomFrequencyEnum, interval: number, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, monthOfYear?: Types.MonthOfYearEnum | null } | null, endScheduleInfo?: { endScheduleType: Types.EndScheduleTypeEnum, date?: string | null, numberOfOccurrences?: number | null } | null } | null };


export type ListRecurringOfflineEventFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ListRecurringOfflineEventFragmentDoc = /*#__PURE__*/ gql`
    fragment ListRecurringOfflineEvent on RecurringOfflineEventType {
  id
  name
  description
  objective
  status
  type
  latestUpcomingEventId
  recurringEventSlotCount
  shareConfigs {
    ...ShareConfig
  }
  sharedByWorkspace {
    ...SharedByWorkspace
  }
  instructors {
    ...EventInstructor
  }
  cover {
    mediaId
    name
    url
    kind
  }
  startTime
  endTime
  usersCount
  isFillingFast
  registrationSettings {
    seatLimit
    closeRegistrationBeforeStart
    multiSlotRegistration
  }
  isUserRegistered
  registrationCloseTime
  isUserInstructor
  recurringCategory
  recurrenceSchedule {
    ...Schedule
  }
}
    `;